import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const deleteRetiredSchedules = api(async function deleteRetiredSchedules(ids) {
    return mutate(
        gql`
            mutation DeleteRetired($ids: [String!]!) {
                deleteRetiredSchedules(ids: $ids)
            }
        `,
        { ids },
        { returns: "deleteRetiredSchedules" }
    )
})
